import { motion } from "framer-motion";
import React, { useState } from "react";

const RadioButtons = ({kind, buttons, selected, setSelected}) => {
  return (
    <div className="flex items-center flex-wrap gap-2">
      {buttons.map((tab) => (
        <button
          key={`${kind}${tab}`}
          onClick={() => setSelected(tab)}
          className={`${
            selected === tab
              ? "text-white"
              : "text-slate-900 hover:text-slate-200 hover:bg-ssblue"
          } text-sm transition-colors px-2.5 py-0.5 rounded-md relative`}
        >
          <span className="relative z-10">{tab}</span>
          {selected === tab && (
            <motion.span
              layoutId={kind}
              transition={{ type: "spring", duration: 0.5 }}
              className="absolute inset-0 z-0 bg-gradient-to-r from-ssblue to-sspurple rounded-md"
            ></motion.span>
          )}
        </button>
      ))}
    </div>
  );
};

export default RadioButtons;
